import type { PasswordFieldProps } from '@capsule/consumer-design-system';
import { PasswordField } from '@capsule/consumer-design-system';

import { getIn, useFormikContext } from 'formik';

interface FormikPasswordFieldProps extends Omit<PasswordFieldProps, 'name'> {
  /** @default "password" */
  name?: string;
}

export const FormikPasswordField = ({ name = 'password', onBlur, onChange, ...props }: FormikPasswordFieldProps) => {
  const { errors, touched, values, handleBlur, handleChange } = useFormikContext();
  const error = getIn(touched, name) && getIn(errors, name);
  const value = getIn(values, name);

  return (
    <PasswordField
      name={name}
      value={value}
      error={error}
      onBlur={event => {
        onBlur?.(event);
        handleBlur(event);
      }}
      onChange={event => {
        onChange?.(event);
        handleChange(event);
      }}
      {...props}
    />
  );
};
